var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRelatedEntityCompany({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 124,
    cy: 123.5,
    r: 123.5,
    fill: "#F2F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.2982 1.02298C9.12481 0.914638 8.90626 0.908896 8.72738 1.00798C8.54854 1.10712 8.43757 1.2955 8.43757 1.49999V4.18814L2.70187 7.77284C2.5374 7.87568 2.4375 8.05591 2.4375 8.24986V15.9374H1.5C1.18933 15.9374 0.9375 16.1892 0.9375 16.4999C0.9375 16.8105 1.18933 17.0624 1.5 17.0624H16.5C16.8107 17.0624 17.0625 16.8105 17.0625 16.4999C17.0625 16.1892 16.8107 15.9374 16.5 15.9374H15.5625V5.24986C15.5625 5.05591 15.4626 4.87568 15.2981 4.77284L9.2982 1.02298ZM14.4375 15.9375V5.56183L9.5625 2.51503V15.9376L14.4375 15.9375ZM8.4375 15.9375V5.51488L3.5625 8.56168V15.9373L8.4375 15.9375Z",
    fill: "#003D50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelatedEntityCompany);
export default __webpack_public_path__ + "static/media/RelatedEntityCompany.7af91a9aa7d40763860312bc9912548b.svg";
export { ForwardRef as ReactComponent };